import { Nav, Tab } from "react-bootstrap";
import { IThirdPartyCorrespondenceDetails } from "../../../api/IThirdPartyCorrespondence";
import { ILicenceProfile } from "../../../api/LicenceProfile";
import { DocumentsGrid } from "../../../leap-components/Documents/DocumentsGrid";
import EpaCard from "../../../leap-components/EpaCard";

interface SubTabsProps {
  className?: string;
  activeKey: string;
  licenceProfile: ILicenceProfile;
  thirdPartyCorrespondence: IThirdPartyCorrespondenceDetails;
}

interface ThirdPartyCorrespondenceProps {
  licenceProfile: ILicenceProfile;
  thirdPartyCorrespondence: IThirdPartyCorrespondenceDetails;
}

const SubTabs = ({
  className,
  activeKey,
  licenceProfile,
  thirdPartyCorrespondence,
}: SubTabsProps) => (
  <div className={"tab " + className}>
    <Tab.Container id="left-tabs-example" defaultActiveKey={activeKey}>
      <Nav variant="tabs">
        <Nav.Item>
          <Nav.Link eventKey="documents">Documents</Nav.Link>
        </Nav.Item>
      </Nav>
      <Tab.Content>
        <Tab.Pane eventKey="documents">
          <DocumentsGrid
            regardingObjectId={
              thirdPartyCorrespondence.thirdpartycorrespondenceid
            }
          />
        </Tab.Pane>
      </Tab.Content>
    </Tab.Container>
  </div>
);

const RelatedComplianceRecords = ({
  thirdPartyCorrespondence,
  licenceProfile,
}: ThirdPartyCorrespondenceProps) => {
  var bodyElements = (
    <SubTabs
      activeKey="documents"
      thirdPartyCorrespondence={thirdPartyCorrespondence}
      licenceProfile={licenceProfile}
    />
  );

  return (
    <EpaCard title={"Related Compliance Records"} content={bodyElements} />
  );
};

export default RelatedComplianceRecords;
